import MfaAuthenticationStatus from "./MfaAuthenticationStatus";

export default MfaAuthenticationStatus;
